import { render, staticRenderFns } from "./ComboCheckItemsTable.vue?vue&type=template&id=8afca522"
import script from "./ComboCheckItemsTable.vue?vue&type=script&lang=js"
export * from "./ComboCheckItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports